import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const SCROLL_KEY = "np-scroll-positions";

function getStore(): Record<string, number> {
  try {
    return JSON.parse(sessionStorage.getItem(SCROLL_KEY) || "{}");
  } catch {
    return {};
  }
}

const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();
  const navType = useNavigationType();
  const prevKey = useRef<string>("");

  // Save scroll position before navigating away
  useEffect(() => {
    const saveScroll = () => {
      if (prevKey.current) {
        const store = getStore();
        store[prevKey.current] = window.scrollY;
        sessionStorage.setItem(SCROLL_KEY, JSON.stringify(store));
      }
    };

    return () => {
      saveScroll();
      prevKey.current = key;
    };
  }, [key]);

  useEffect(() => {
    prevKey.current = key;

    if (navType === "POP") {
      // Back/forward navigation: restore saved position
      const store = getStore();
      const saved = store[key];
      if (saved !== undefined) {
        // Use requestAnimationFrame to wait for DOM render
        requestAnimationFrame(() => {
          window.scrollTo(0, saved);
        });
        return;
      }
    }

    // Fresh navigation: scroll to top
    window.scrollTo(0, 0);
  }, [pathname, search, key, navType]);

  return null;
};

export default ScrollToTop;
